import type { EnhancedAppointment, IListing } from '@bb/domain/dist/types';
import Axios from 'axios';

const findListingConfirmed = async (listingId: string) => {
  const { data } = await Axios.get<
    {
      listing: IListing;
      appointment: EnhancedAppointment;
    }[]
  >(`/listing/${listingId}/appointments/confirmed`);
  return data;
};
export default findListingConfirmed;
